export const SidebarCategoryTitle = (props: { title: string }) => {
  const { title } = props;
  return <div className="mb-2 px-3 text-xs text-white text-left opacity-50">{title}</div>;
};
